<template>
  <div>
    <div class="modal-backdrop fade show"></div>

    <div
        class="modal fade show modal-dialog-centered modal-dialog-scrollable"
        style="padding-right: 12px; display: block;">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isAdd ? 'Новое функциональное состояние' : 'Редактирование' }}.
            </h5>

            <button type="button" class="close" @click="$emit('cancel')">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div class="modal-body">
            <form>
              <div class="form-group">
                <label>Функциональное состояние</label>
                <SelectSearch
                    v-if="isAdd"
                    :data="data"
                    placeholder="Выбирете"
                    v-model="functional"/>

                <input
                    v-else
                    class="form-control"
                    type="text"
                    :value="functionalTitle"
                    disabled/>
              </div>

              <div class="form-group">
                <label>Дата постановки</label>
                <input type="text" class="form-control" v-model="dateFrom"/>
                <small class="form-text text-muted">формат: YYYY-MM-DD</small>
              </div>

              <div class="form-group">
                <label>Дата снятия</label>
                <input type="text" class="form-control" v-model="dateTo"/>
                <small class="form-text text-muted">формат: YYYY-MM-DD</small>
              </div>

              <div class="form-group">
                <label>Комментарий</label>
                <textarea class="form-control" v-model="note"></textarea>
              </div>
            </form>

            <div v-if="error" class="alert alert-danger">{{ error }}</div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button v-if="!isAdd" type="button" class="btn btn-danger" @click="deleteItem">
                Удалить
              </button>
            </div>

            <div>
              <button type="button" class="btn btn-primary" @click="submitForm">
                {{ isAdd ? 'Добавить' : 'Обновить' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../../utils/formatDate';
import SelectSearch from '../../../common/SelectSearch';

export default {
  name: 'ClientConclusionFunctionalForm',

  components: {SelectSearch},

  props: ['functionals', 'establishment'],

  data() {
    return {
      error: '',
      functional: '',
      note: '',
      dateFrom: formatDate(new Date(), 'y-m-d'),
      dateTo: '',
    };
  },

  created() {
    if (typeof this.establishment !== 'undefined') {
      this.functional = this.establishment.functional;
      this.note = this.establishment.note;
      this.dateFrom = formatDate(new Date(this.establishment.dateFrom), 'y-m-d');

      if (typeof this.establishment.dateTo === 'string' && this.establishment.dateTo.trim() !== '') {
        this.dateTo = formatDate(new Date(this.establishment.dateTo), 'y-m-d');
      }
    }
  },

  computed: {
    isAdd() {
      return typeof this.establishment === 'undefined';
    },

    data() {
      return this.functionals.map(functional => {
        return {
          label: functional.title,
          value: functional.id,
        };
      });
    },

    functionalTitle() {
      if (typeof this.establishment === 'undefined') {
        return '?';
      }

      const functional = this.functionals.find(i => i.id === this.establishment.functional);

      return typeof functional !== 'undefined' ? functional.title : '?';
    },
  },

  methods: {
    submitForm() {
      this.error = '';

      if (typeof this.functional !== 'string' || this.functional.trim() === '') {
        this.error = 'Функциональное состояние не выбрано';
      }

      if (typeof this.dateFrom !== 'string' || this.dateFrom.trim() === '') {
        this.error = 'Дата постановки не указана';
      }

      if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.dateFrom) !== true) {
        this.error = `Дата постановки указана неправильно`;
      }

      if (typeof this.dateTo === 'string' && this.dateTo.trim() !== '') {
        if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.dateTo) !== true) {
          this.error = `Дата снятия указана неправильно`;
        } else if (new Date(this.dateTo) < new Date(this.dateFrom)) {
          this.error = `Дата снятия не может быть раньше даты постановки`;
        }
      }

      if (this.error !== '') {
        return;
      }

      const data = {
        functional: this.functional,
        note: this.note,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      };

      if (typeof this.establishment !== 'undefined') {
        data.id = this.establishment.id;
      }

      this.$emit('submit', data);
    },

    deleteItem() {
      if (!this.isAdd && typeof this.establishment.id === 'string') {
        this.$emit('delete', this.establishment.id);
      }
    },
  },
};
</script>
